import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControl from "@material-ui/core/FormControl";
import CheckIcon from "@material-ui/icons/CheckTwoTone";
import FormLabel from "@material-ui/core/InputLabel";
import WarinigIcon from "@material-ui/icons/WarningRounded";
import {
  TextField,
  Checkbox,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";
import { DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import HttpModule, { HTTP_PROGRESS } from "../../services/http.module";
import CloseIcon from "@material-ui/icons/CloseSharp";
import PendingIcon from "@material-ui/core/CircularProgress";

/**
 *
 * @param {Number} min
 * @param {Number} max
 * @returns {Array<Number>}
 */
const Range = (min, max) => {
  const arr = [];
  for (min; min < max; min++) arr.push(min);
  return arr;
};
const YesNoQuestionBox = ({ CallBack, Statement, Options }) => {
  const [btnState, setBtnState] = React.useState("");
  React.useEffect(() => {
    setBtnState("");
  }, [Statement]);
  const yes = () => {
    setBtnState("y");
    CallBack("y");
  };
  const no = () => {
    setBtnState("n");
    CallBack("n");
  };
  return (
    <>
      {Statement}
      <Button
        onClick={yes}
        variant="contained"
        color={btnState === "y" ? "secondary" : "inherit"}
        className="mr-2 ml-2"
      >
        {Options["yes"]}
      </Button>
      <Button
        onClick={no}
        variant="contained"
        color={btnState === "n" ? "secondary" : "inherit"}
      >
        {Options["no"]}
      </Button>
    </>
  );
};
const TextQuestionBox = ({ CallBack, Statement, Intracted }) => {
  return (
    <>
      <TextField
        variant="outlined"
        className="col-6"
        multiline
        rows={1}
        rowsMax={7}
        onBlur={(e) => {
          CallBack(e.target.value);
        }}
        placeholder={Statement}
      />
    </>
  );
};
const InputTypes = {
  yn: YesNoQuestionBox,
  txt: TextQuestionBox,
};
const QuestionBox = ({
  Question,
  Alter,
  Condition,
  index,
  Options,
  GetData,
  id,
  ActiveNext,
}) => {
  const [canGoAlter, setAlter] = React.useState(false);
  const [firstQuestion, setFirstQuestion] = React.useState();
  const [secondQuestion, setSecondQuestion] = React.useState("");
  const [canGoNext, setNext] = React.useState(false);
  const [intract, setIntract] = React.useState(false);

  const Component = InputTypes[Alter.type];

  React.useEffect(() => {
    GetData(
      {
        one: firstQuestion,
        two: secondQuestion,
        id,
      },
      index
    );
  }, [firstQuestion, secondQuestion]);

  React.useEffect(() => {
    ActiveNext(canGoNext);
  }, [intract, canGoNext]);

  React.useEffect(() => {
    setAlter(false);
    setFirstQuestion();
    setSecondQuestion("");
    ActiveNext(false);
  }, [Question]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <YesNoQuestionBox
            Statement={`${index}-${Question}`}
            CallBack={(v) => {
              setAlter(v === Condition ? true : false);
              setNext(v !== Condition);
              setIntract(!intract);
              setFirstQuestion(v === "y" ? 1 : 0);
            }}
            Options={Options}
          />
        </div>
      </div>
      {canGoAlter ? (
        <div className="row p-2">
          <div className="col-12">
            <Component
              Statement={Alter.Question}
              CallBack={(v) => {
                setSecondQuestion(v);
                setNext(!canGoNext && v.length >= 0);
                setIntract(!intract);
              }}
              Options={Alter.Options}
            />
          </div>
        </div>
      ) : (
        <> </>
      )}
    </>
  );
};

export class Refrandom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      min: 1,
      max: this.props["jsonData"].length,
      index: 1,
      form: this.props["jsonData"],
      NextLevel: false,
      YesNoStatement: "",
      SelectedOptions: [],
      Others: "",
      ComponentStyle: {},
      formData: null,
      dialogOpenStatus: true,
      errorData: null,
      DataSubmited: "",
      goNext: false,
      KidBirthdayYear: "",
      KidBirthdayMonth: "",
      KidBirthdayDay: "",
      IdCode: "",
    };
  }

  #data = [];

  HandleData = (data, index) => {
    this.#data[index - 1] = data;
  };

  HandleCheckBox = (e, v) => {
    const mockData = this.state.SelectedOptions;
    if (v) mockData.push(e.target.name);
    else {
      const index = mockData.indexOf(e.target.name);
      if (index >= 0) mockData.splice(index, 1);
    }
    this.setState(
      {
        SelectedOptions: mockData,
      },
      () => {}
    );
  };

  HandleInputs = (name) => (v) => {
    this.setState({
      [name]: v.target.value,
    });
  };

  DialogClose = (e) => {
    this.SubmitDialogData([
      "Address",
      "PhoneNumber",
      "KidBirthdayDay",
      "KidBirthdayMonth",
      "KidBirthdayYear",
      "KidLastName",
      "KidName",
      "IdCode",
    ])(e);
  };

  SubmitDialogData = (validateFields) => (e) => {
    let valid = true;
    const data = {};

    for (const field of validateFields) {
      console.log(field);
      if (!this.state[field]) {
        valid = false;
        const jsx = (
          <>
            <Typography
              className="text-warning text-right"
              align="center"
              variant="h6"
            >
              <WarinigIcon />
              لطفا تمامی فیلد ها را پر کنید
            </Typography>
          </>
        );
        this.setState({
          errorData: jsx,
        });
        break;
      } else {
        data[field] = this.state[field];
      }
    }

    if (valid) {
      this.setState(
        {
          dialogOpenStatus: false,
          formData: data,
        },
        () => console.log(this.state.formData)
      );
    }
  };

  SendData = (data) => {
    this.setState({
      DataSubmited: HTTP_PROGRESS.PENDING,
    });
    HttpModule.SubmitTestData(data)
      .then((_) => {
        this.setState(
          {
            DataSubmited: HTTP_PROGRESS.DONE,
          },
          () => {
            this.props.onDone();
          }
        );
      })
      .catch((e) => {
        this.setState({
          DataSubmited: HTTP_PROGRESS.FAILED,
        });
      });
  };

  BundleData = () => {
    const allData = {
      Info: this.state.formData,
      YesNo: this.#data,
      Last: {
        Selected: this.state.SelectedOptions || [],
        Ohters: this.state["Others"],
        MotherAndKid: this.state["MotherAndKid"] || "",
      },
    };
    this.SendData(allData);
  };

  render() {
    return (
      <>
        {/* {this.state['form'].map((item ,  index) => {
                return <div className="row p-3" key={`QuestionBox-${index}`}>
                    <div className="col-12">
                        <QuestionBox  index={index + 1} {...item} />
                    </div>
                </div>
            })} */}
        <Dialog
          open={this.state.dialogOpenStatus}
          onClose={this.DialogClose}
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h4" className="p-1">
              مشخصات
            </Typography>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 p-2">
                <TextField
                  className="w-100"
                  label="نام کودک"
                  variant="outlined"
                  color="secondary"
                  onChange={this.HandleInputs("KidName")}
                />
              </div>
              <div className="col-12 p-2">
                <TextField
                  className="w-100"
                  label="نام خانوادگی کودک"
                  variant="outlined"
                  color="secondary"
                  onChange={this.HandleInputs("KidLastName")}
                />
              </div>
              <div className="col-12 p-2">
                <TextField
                  className="w-100"
                  label="کد ملی کودک"
                  variant="outlined"
                  color="secondary"
                  onChange={this.HandleInputs("IdCode")}
                />
              </div>
              <div className="col-12 p-2">
                <div className="row">
                  <FormControl className="col-3 mr-3 ml-1">
                    <FormLabel id="KBD" variant="outlined">
                      {" "}
                      روز تولد{" "}
                    </FormLabel>
                    <Select
                      labelId="KBD"
                      label="روز تولد"
                      variant="outlined"
                      color="secondary"
                      value={this.state.KidBirthdayDay}
                      onChange={this.HandleInputs("KidBirthdayDay")}
                    >
                      {Range(1, 32).map((item, index) => (
                        <MenuItem value={item} key={index}>
                          {" "}
                          {item}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl className="col-3 mr-3 ml-1">
                    <FormLabel id="KBD" variant="outlined">
                      {" "}
                      ماه تولد{" "}
                    </FormLabel>
                    <Select
                      labelId="KBD"
                      label="ماه تولد"
                      variant="outlined"
                      color="secondary"
                      value={this.state.KidBirthdayMonth}
                      onChange={this.HandleInputs("KidBirthdayMonth")}
                    >
                      {Range(1, 13).map((item, index) => (
                        <MenuItem value={item} key={index}>
                          {" "}
                          {item}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl className="col-3 mr-3 ml-1">
                    <FormLabel id="KBD" variant="outlined">
                      {" "}
                      سال تولد{" "}
                    </FormLabel>
                    <Select
                      labelId="KBD"
                      label="سال تولد"
                      variant="outlined"
                      color="secondary"
                      value={this.state.KidBirthdayYear}
                      onChange={this.HandleInputs("KidBirthdayYear")}
                    >
                      {Range(1380, 1401).map((item, index) => (
                        <MenuItem value={item} key={index}>
                          {" "}
                          {item}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-12 p-2">
                <TextField
                  className="w-100"
                  label="تلفن تماس ضروری"
                  variant="outlined"
                  color="secondary"
                  onChange={this.HandleInputs("PhoneNumber")}
                />
              </div>
              <div className="col-12 p-2">
                <TextField
                  className="w-100"
                  label="آدرس دقیق منزل"
                  variant="outlined"
                  color="secondary"
                  onChange={this.HandleInputs("Address")}
                />
              </div>
              <div className="col-12 p-2">
                {this.state.errorData === null ? <></> : this.state.errorData}
              </div>
            </div>
          </DialogContent>
          <DialogActions className="text-center ">
            <Button
              variant="contained"
              color="secondary"
              onClick={this.SubmitDialogData([
                "Address",
                "PhoneNumber",
                "KidBirthdayDay",
                "KidBirthdayMonth",
                "KidBirthdayYear",
                "KidLastName",
                "KidName",
                "IdCode",
              ])}
            >
              <CheckIcon className="mr-2 ml-2" />
              ثبت و ادامه
            </Button>
          </DialogActions>
        </Dialog>
        {!this.state.NextLevel ? (
          <>
            <div
              style={{
                transition: "0.25s ease",
                ...this.state.ComponentStyle,
              }}
            >
              <QuestionBox
                index={this.state.index}
                {...this.state.form[this.state.index - 1]}
                GetData={this.HandleData}
                ActiveNext={(v) => {
                  this.setState({
                    goNext: v,
                  });
                }}
              />
            </div>
            <div className="row pt-5">
              <div className="col-3 text-center">
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={this.state.index === this.state.min}
                  onClick={() => {
                    this.setState(
                      {
                        ComponentStyle: {
                          opacity: 0,
                        },
                      },
                      () => {
                        setTimeout(() => {
                          this.setState({
                            index: this.state.index - 1,
                            ComponentStyle: {
                              opacity: 1,
                            },
                          });
                        }, 500);
                      }
                    );
                  }}
                >
                  قبلی
                </Button>
              </div>
              <div className="col-6 text-center p-2">
                {this.state.index === this.state.max ? (
                  <> {this.state.index} </>
                ) : (
                  <>
                    {this.state.index} - {this.state.max}
                  </>
                )}
              </div>
              <div className="col-3">
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!this.state.goNext}
                  onClick={() => {
                    if (this.state.index != this.state.max)
                      this.setState(
                        {
                          ComponentStyle: {
                            opacity: 0,
                          },
                        },
                        () => {
                          setTimeout(() => {
                            this.setState({
                              index: this.state.index + 1,
                              ComponentStyle: {
                                opacity: 1,
                              },
                            });
                          }, 500);
                        }
                      );
                    else {
                      this.setState({
                        NextLevel: true,
                      });
                    }
                  }}
                >
                  {this.state.index === this.state.max ? "مرحله بعد" : "بعدی"}
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            {this.state.DataSubmited === "" ? (
              <>
                <YesNoQuestionBox
                  Statement={`24-آیا کودک شما عادت خاص رفتاری دارد ؟`}
                  CallBack={(v) => {
                    this.setState({
                      YesNoStatement: v === "y" ? 1 : 0,
                    });
                  }}
                  Options={{
                    yes: "بلی",
                    no: "خیر",
                  }}
                />

                <div className="row">
                  <div className="col-12">
                    <FormControl>
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name=" وابستگی به پتو و عروسک و ..."
                          />
                        }
                        label=" وابستگی به پتو و عروسک و ..."
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="مکیدن انگشت"
                          />
                        }
                        label=" مکیدن انگشت"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="خود تحریکی یا مسله جنسی"
                          />
                        }
                        label="خود تحریکی یا مسله جنسی"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="بازی با پستان مادر"
                          />
                        }
                        label="بازی با پستان مادر"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="جویدن ناخن"
                          />
                        }
                        label="جویدن ناخن"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="مشکلات دفعی"
                          />
                        }
                        label="مشکلات دفعی"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="بازی با بازوی مادر"
                          />
                        }
                        label="بازی با بازوی مادر"
                      />
                      <FormLabel
                        control={
                          <Checkbox
                            color="secondary"
                            onChange={this.HandleCheckBox}
                            name="شب ادراری"
                          />
                        }
                        label="شب ادراری"
                      />
                      <TextField
                        label={"سایر موارد"}
                        color="secondary"
                        variant="outlined"
                        onChange={this.HandleInputs("Others")}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row p-5">
                  <div className="col-2 text-left">
                    25- مسائل و مشکلات خود را در ارتباط با کودک جهت اطلاع
                    درمانگر مربوطه یادداشت کنید
                  </div>
                  <TextField
                    variant="outlined"
                    color="secondary"
                    className="col-6"
                    multiline
                    rows={5}
                    rowsMax={8}
                    label="مسائل مادر و کودک"
                    onChange={this.HandleInputs("MotherAndKid")}
                  />
                </div>
                <div className="row">
                  <div className="col-6 text-center p-5">
                    <Button
                      color="secondary"
                      variant="contained"
                      className="pr-3 pl-3"
                      onClick={this.BundleData}
                    >
                      ثبت
                    </Button>
                  </div>
                  <div className="col-6 text-center p-5">
                    <Button
                      color="secondary"
                      variant="contained"
                      className="pr-3 pl-3"
                      onClick={() => {
                        this.setState({
                          NextLevel: false,
                          index: this.state.max,
                        });
                      }}
                    >
                      بازگشت
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className="row p-5">
                <div className="col-12">
                  {this.state.DataSubmited === HTTP_PROGRESS.DONE ? (
                    <Typography className="text-success" align="center">
                      <CheckIcon className="text-success" />
                      با موفقیت ثبت شد ، ممنون از مشارکت شما
                    </Typography>
                  ) : (
                    ""
                  )}
                  {this.state.DataSubmited === HTTP_PROGRESS.FAILED ? (
                    <Typography className="text-danger" align="center">
                      <CloseIcon className="text-danger" />
                      خطا در ثبت اطلاعات
                    </Typography>
                  ) : (
                    ""
                  )}
                  {this.state.DataSubmited === HTTP_PROGRESS.PENDING ? (
                    <>
                      <PendingIcon />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

export default Refrandom;
